// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PayoutInfo_wrapper__QLkOR","field":"PayoutInfo_field__1EVjJ","fieldRow":"PayoutInfo_fieldRow__hqzWo","info":"PayoutInfo_info__3Ffdq"};